<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />

    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="">
      <div class="py-10">
        <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10">
          <div>
            <form
              ref="addCourseRef"
              class="rounded-2xl pt-10 px-4 md:px-10 pb-2 heightfix overflow-y-auto bg-white"
              style="box-shadow: 0px 2px 20px 0px #105c8e26"
              @submit.prevent="updateDetails"
            >
              <div class="flex items-center justify-between gap-4">
                <div>
                  <h1 class="py-2 text-lg text-center font-bold text-blues">
                    Edit Course
                  </h1>
                </div>

                <router-link
                  :to="{ name: 'AdminCoursess' }"
                  class="bg-blues text-white hover:bg-[#18469d] hover:text-white rounded-lg text-sm font-semibold px-3 py-1"
                  >Back</router-link
                >
              </div>

              <div class="py-10 flex flex-col gap-6">
                <div
                  class="flex flex-col lg:flex-row items-center gap-5 w-full"
                >
                  <div class="flex flex-col gap-3 w-full">
                    <label for="title" class="text-sm"
                      >Title <span class="text-red-400">*</span></label
                    >
                    <input
                      id="title"
                      v-model="courseInfo.title"
                      type="text"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <div class="flex flex-col gap-3 w-full">
                    <label for="category" class="text-sm"
                      >Category <span class="text-red-400">*</span></label
                    >
                    <select
                      name="category"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                      id="category"
                    >
                      <option
                        v-for="category in categories"
                        :key="category"
                        :value="category.id"
                      >
                        {{ category.title }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="flex flex-col gap-3 w-full">
                  <label for="shortDesc" class="text-sm">
                    Course objective is to
                    <span class="text-red-400">*</span></label
                  >
                  <textarea
                    id="shortDesc"
                    required
                    v-model="courseInfo.short_description"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div class="flex flex-col gap-1">
                    <label for="name">
                      Order
                      <span class="text-red-400">*</span>
                    </label>
                    <input
                      id="order"
                      v-model="courseInfo.ordered"
                      type="text"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                </div>

                <!-- Faculty -->

                <div class="flex flex-col gap-3">
                  <label class="text-sm font-medium">Select Faculty</label>
                  <ul
                    class="w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1 p-2 space-y-2"
                    :class="
                      instructor_lists.length === 0 ? 'bg-gray-200' : 'bg-white'
                    "
                  >
                    <li
                      v-for="instructor in instructor_lists"
                      :key="instructor.id"
                      class="flex items-center gap-2 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        :value="instructor.id"
                        v-model="courseInfo.instructor"
                        class="form-checkbox accent-blue-600"
                      />
                      <span>{{ instructor.user.email }}</span>
                    </li>
                  </ul>
                </div>

                <div class="flex flex-col gap-3 w-full">
                  <label for="description" class="text-sm"
                    >Description <span class="text-red-400">*</span></label
                  >
                  <QuillEditor
                    style="height: 300px"
                    theme="snow"
                    class="border rounded-2xl"
                    toolbar="full"
                    :content="courseInfo.description"
                    @update:content="courseInfo.description = $event"
                    contentType="html"
                  />
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div class="flex flex-col gap-3">
                    <label for="program_name" class="text-sm flex gap-2"
                      >Program Name <span class="text-red-400">*</span>
                    </label>
                    <select
                      id="program_id"
                      v-model="courseInfo.program"
                      required
                      @change="getProgramsFilter()"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    >
                      <option value="" selected disabled>
                        Select Programs
                      </option>
                      <option
                        :selected="program.id == courseInfo.program"
                        v-for="program in programs"
                        :key="program.id"
                        :value="program.id"
                      >
                        {{ program.name }}
                      </option>
                    </select>
                  </div>
                  <div class="flex flex-col gap-3">
                    <label for="department" class="text-sm flex gap-2"
                      >Departments <span class="text-red-400">*</span>
                    </label>
                    <select
                      id="department"
                      v-model="courseInfo.department"
                      @change="getSemesterFilter()"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    >
                      <option value="" selected disabled>
                        Select Department
                      </option>
                      <option
                        v-for="department in departments"
                        :selected="department.id == courseInfo.department"
                        :key="department.id"
                        :value="department.id"
                      >
                        {{ department.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div class="flex flex-col gap-3">
                    <label for="semester" class="text-sm flex gap-2"
                      >Semester<span class="text-red-400">*</span>
                    </label>
                    <select
                      id="semester"
                      v-model="courseInfo.semester"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    >
                      <option value="" selected disabled>
                        Select Semester
                      </option>
                      <option
                        v-for="semester in semetser_list"
                        :key="semester"
                        :value="semester.id"
                        :selected="semester.id == courseInfo.semester"
                      >
                        {{ semester.semester }}
                      </option>
                    </select>
                  </div>

                  <div class="flex flex-col gap-3">
                    <label for="section" class="text-sm"
                      >Section <span class="text-red-400">*</span></label
                    >
                    <select
                      id="section"
                      v-model="courseInfo.class_section"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    >
                      <option value="" selected disabled>Select Section</option>
                      <option
                        v-for="section in sections"
                        :key="section"
                        :value="section.id"
                        :selected="section.id == courseInfo.class_section"
                      >
                        {{ section.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div class="flex flex-col gap-3">
                    <label for="course_code" class="text-sm"
                      >Course Code <span class="text-red-400">*</span></label
                    >
                    <input
                      id="course_code"
                      type="text"
                      v-model="courseInfo.course_code"
                      maxlength="30"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>

                  <div class="flex flex-col gap-3">
                    <label for="category" class="text-sm flex gap-2"
                      >Course Type <span class="text-red-400">*</span>
                      <!-- <font-awesome-icon
                      @click="isCourseTypePopup = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    /> -->
                    </label>
                    <!--  :selected="type.id == courseInfo.course_type.id" -->
                    <select
                      id="course_type"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    >
                      <option value="" selected disabled>
                        Select Course Type
                      </option>
                      <option
                        :selected="type.id == courseInfo.course_type"
                        v-for="type in courseTypeList"
                        :key="type.id"
                        :value="type.id"
                      >
                        {{ type.title }}
                      </option>
                    </select>
                  </div>

                  <div class="flex flex-col gap-3">
                    <label for="credits" class="text-sm"
                      >Credits<span class="text-red-400">*</span></label
                    >
                    <input
                      id="credits"
                      type="number"
                      v-model="courseInfo.credits"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <div class="flex flex-col gap-3">
                    <label for="exam_duration" class="text-sm flex gap-2"
                      >Exam Duration <span class="text-red-400">*</span>
                    </label>
                    <input
                      id="exam_duration"
                      type="number"
                      v-model="courseInfo.exam_duration"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <div class="flex flex-col gap-3">
                    <label for="cie" class="text-sm"
                      >CIE<span class="text-red-400">*</span></label
                    >
                    <input
                      id="cie"
                      type="number"
                      v-model="courseInfo.cie"
                      @input="addNumber"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <div class="flex flex-col gap-3">
                    <label for="see" class="text-sm flex gap-2"
                      >SEE <span class="text-red-400">*</span>
                    </label>
                    <input
                      id="see"
                      type="number"
                      @input="addNumber"
                      v-model="courseInfo.see"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <div class="flex flex-col gap-3">
                    <label for="total" class="text-sm flex gap-2">Total </label>
                    <input
                      id="total"
                      type="number"
                      :value="courseInfo.see + courseInfo.cie"
                      disabled
                      required
                      class="bg-[#eaeaeb] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <!-- <div class="flex flex-col gap-3">
                    <label for="total_contact_hours" class="text-sm flex gap-2"
                      >Total Contact Hours <span class="text-red-400">*</span>
                    </label>
                    <input
                      id="total_contact_hours"
                      type="number"
                      v-model="courseInfo.total_contact_hours"
                      min="1" 
                      max="10"
                      @input="validateNumber('total_contact_hours')"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div> -->
                  <div class="flex flex-col gap-3">
                    <label for="total_contact_hours" class="text-sm flex gap-2"
                      >Total Contact Hours <span class="text-red-400">*</span>
                    </label>
                    <input
                      id="total_contact_hours"
                      type="text"
                      v-model="courseInfo.total_contact_hours"
                      maxlength="4"
                      @blur="convertTimeOnBlur"
                      required
                      placeholder="HH:MM"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <!-- <div class="flex flex-col gap-3">
                    <label for="no_of_contact_hours" class="text-sm flex gap-2"
                      >No of Contact Hours <span class="text-red-400">*</span>
                    </label>
                    <input
                      id="no_of_contact_hours"
                      type="number"
                      min="1" 
                      v-model="courseInfo.no_of_contact_hours"
                      max="10"
                      @input="validateNumber('no_of_contact_hours')"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>

                  <div class="flex flex-col gap-3">
                    <label for="tutor_hours" class="text-sm flex gap-2"
                      >Tutor Hours <span class="text-red-400">*</span>
                    </label>
                    <input
                      id="tutor_hours"
                      type="text"
                      v-model="courseInfo.tutor_hours"
                      @input="validateNumber('tutor_hours')"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>

                  <div class="flex flex-col gap-3">
                    <label for="practical_hours" class="text-sm flex gap-2"
                      >Practical Hours <span class="text-red-400">*</span>
                    </label>
                    <input
                      id="practical_hours"
                      type="text"
                      v-model="courseInfo.practical_hours"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>

                  <div class="flex flex-col gap-3">
                    <label for="ltp" class="text-sm flex gap-2"
                      >LTP <span class="text-red-400">*</span>
                    </label>
                    <input
                      id="ltp"
                      v-model="courseInfo.ltp"
                      type="text"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div> -->
                </div>

                <!-- <div class="flex flex-col gap-3 w-full">
                  <label for="outcome" class="text-sm">Outcome</label>
                  <textarea
                    id="outcome"
                    v-model="courseInfo.outcome"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div> -->

                <div class="flex flex-col gap-3 w-full">
                  <label for="requirement" class="text-sm">Requirement</label>
                  <textarea
                    id="requirement"
                    v-model="courseInfo.requirements"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>

                <div
                  class="flex flex-col lg:flex-row items-center gap-5 w-full"
                >
                  <div class="flex flex-col gap-3 w-full">
                    <label for="language" class="text-sm"
                      >Language <span class="text-red-400">*</span></label
                    >

                    <select
                      name="level"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                      id="languages"
                    >
                      <option
                        v-for="lang in languageList"
                        :selected="lang.id == courseInfo.languages"
                        :key="lang.id"
                        :value="lang.id"
                      >
                        {{ lang.title }}
                      </option>
                    </select>
                  </div>
                  <div class="flex flex-col gap-3 w-full">
                    <label for="level" class="text-sm">Level</label>
                    <select
                      name="level"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                      id="level"
                    >
                      <option
                        v-for="level in [
                          'beginner',
                          'intermediate',
                          'advanced',
                        ]"
                        :key="level"
                        :value="level"
                      >
                        {{ level }}
                      </option>
                    </select>
                  </div>
                </div>

                <div
                  class="flex flex-col lg:flex-row items-center gap-5 w-full"
                >
                  <div class="flex flex-col gap-3 w-full">
                    <label for="thumbnail" class="text-sm"
                      >Thumbnail <span class="text-red-400">*</span></label
                    >
                    <img
                      :src="courseInfo.thumbnail"
                      class="w-[150px] h-[100px] rounded-lg"
                      alt=""
                    />
                    <input
                      id="thumbnail"
                      type="file"
                      class="bg-[#F9FAFC] object-cover rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>

                  <!-- <div class="flex flex-col gap-3 w-full">
                    <label for="videoUrl" class="text-sm">Video URL</label>
                    <input
                      id="videoUrl"
                      v-model="courseInfo.video_url"
                      type="text"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div> -->

                  <div class="flex flex-col gap-3 w-full">
                    <label for="video_url" class="text-sm">Video URL</label>

                    <div class="w-full">
                      <form
                        enctype="multipart/form-data"
                        class="flex flex-col gap-2 w-full"
                        method="POST"
                        @submit.prevent="
                          uploadFilebyChunkNew('fileuploadvideo', 'video_url')
                        "
                      >
                        <label class="font-bold text-sm"
                          >Select video file to upload.</label
                        >

                        <div class="flex flex-row gap-2 w-full">
                          <input
                            type="file"
                            placeholder="Select Video"
                            class="bg-gray-100 w-[70%] md:w-full rounded-lg p-2 md:p-3 border-none outline-none"
                            id="fileuploadvideo"
                            @change="CheckVideoSizeUpload"
                            accept="video/*"
                            required
                          />
                          <input
                            type="submit"
                            value="Upload"
                            id="submit"
                            class="text-white bg-blues rounded-lg text-xs md:text-sm font-bold p-2 md:px-4 md:py-2 cursor-pointer"
                          />
                        </div>

                        <p v-if="video_error" style="color: red">
                          {{ video_error }}
                        </p>
                        <!-- <div class="flex justify-end">
                       
                      </div> -->
                      </form>
                      <div id="statusCode" class="mt-2"></div>
                    </div>

                    <a
                      :href="courseInfo.video_url"
                      v-if="courseInfo.video_url"
                      class="text-blue-600 text-sm"
                      >Existing Uploaded Video.</a
                    >

                    <input
                      id="video_url"
                      placeholder="Select Video URL"
                      type="text"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />

                    <!-- <p class="text-red-500 text-xs" v-if="isValidUrlBool.video_url == false">Enter valid url.</p>
                  <p class="text-green-800 text-xs" v-if="isValidUrlBool.video_url  == true">URL valid.</p> -->
                  </div>

                  <!-- <p class="text-red-500 text-xs" v-if="isValidUrlBool.video_url == false">Enter valid url.</p>
                  <p class="text-green-800 text-xs" v-if="isValidUrlBool.video_url == true">URL valid.</p> -->
                </div>

                <!-- <div class="flex flex-col gap-3">
                    <label for="pdf_urls" class="text-sm"
                      >PDF URL</label
                    >
                    <input
                      v-model="courseInfo.pdf_urls"
                      id="pdf_urls"
                      type="text"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />                  
                </div> -->
                <div class="flex flex-col gap-3 w-full">
                  <label for="outcome" class="text-sm">Keywords</label>

                  <input
                    v-model="courseInfo.outcome"
                    id="outcome"
                    maxlength="1000"
                    type="text"
                    @input="pdfDisabled = !courseInfo.outcome.trim()"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div
                  class="flex flex-col gap-3"
                 
                >
                  <label for="pdf_urls" class="text-sm flex gap-1 items-center"
                    >PDF URL
                    <div class="relative group" v-if="pdfDisabled">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <div
                        class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                      >
                        Please fill the keywords before uploading the PDF.
                      </div>
                    </div></label
                  >

                  <div class="w-full"  :class="{ 'pointer-events-none opacity-60': pdfDisabled }">
                    <form
                      enctype="multipart/form-data"
                      class="flex flex-col gap-2 w-full"
                      method="POST"
                      @submit.prevent="
                        uploadFilebyChunkNew('fileuploadpdf', 'pdf_urls')
                      "
                    >
                      <label class="font-bold text-sm"
                        >Select pdf file to upload.</label
                      >

                      <div class="flex flex-row gap-2 w-full">
                        <input
                          type="file"
                          placeholder="Select Pdf"
                          class="bg-gray-100 w-[70%] md:w-full rounded-lg p-2 md:p-3 border-none outline-none"
                          accept="application/pdf"
                          id="fileuploadpdf"
                          @change="CheckPdfSizeUpload"
                          required
                        />
                        <input
                          type="submit"
                          value="Upload"
                          id="submit"
                          class="text-white bg-blues rounded-lg text-xs md:text-sm font-bold p-2 md:px-4 md:py-2 cursor-pointer"
                        />
                      </div>

                      <p v-if="pdf_error" style="color: red">{{ pdf_error }}</p>
                    </form>
                    <div id="statusCode" class="mt-2"></div>
                  </div>
                  <a
                    :href="courseInfo.pdf_urls"
                    v-if="courseInfo.pdf_urls"
                    :class="{ 'pointer-events-none opacity-60': pdfDisabled }"
                    class="text-blue-600 text-sm"
                    >Existing Uploaded Pdf.</a
                  >
                  <input
                    id="pdf_urls"
                    type="text"
                    :class="{ 'pointer-events-none opacity-60': pdfDisabled }"
                    placeholder="Select PDF URL"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex items-center gap-4">
                  <div class="flex items-center gap-2">
                    <label for="checkbox">Published</label>
                    <input
                      type="checkbox"
                      id="Published"
                      v-model="courseInfo.is_published"
                    />
                  </div>
                </div>
                <div class="flex gap-3 items-center">
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-gray-200 text-black cursor-not-allowed'
                        : 'bg-teal-800 hover:bg-teal-600 cursor-pointer text-white border-greens'
                    "
                    class="border rounded-lg text-lg font-semibold px-6 py-1.5"
                  >
                    Save
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
class FileUpload1 {
  constructor(input, bar_url, vueContext) {
    this.bar_url = bar_url;
    this.input = input;
    this.max_length = 1024 * 1024 * 1024 * 100;
    this.vue = vueContext;
  }

  create_progress_bar() {
    var progress = `<div class="file-icon">
                        <i class="fa fa-file-o" aria-hidden="true"></i>
                    </div>
                    <div class="file-details">
       
                         <p class="filename1"></p>
                        <small class="textbox1"></small>
                        <div class="progressbar1">
                            <div class="progress1" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">
                            </div>
                        </div>
                    </div>`;
    document.getElementById(this.bar_url).innerHTML = progress;
  }

  upload(append_id) {
    this.create_progress_bar();
    this.initFileUpload(append_id);
  }

  initFileUpload(append_id) {
    this.file = this.input.files[0];
    this.upload_file(0, null, append_id);
  }

  //upload file
  upload_file(start, model_id, append_id) {
    var end;
    var self = this;
    var existingPath = model_id;
    var formData = new FormData();
    var nextChunk = start + this.max_length + 1;
    var currentChunk = this.file.slice(start, nextChunk);
    var uploadedChunk = start + currentChunk.size;
    if (uploadedChunk >= this.file.size) {
      end = 1;
    } else {
      end = 0;
    }

    formData.append("title", "title");

    formData.append("file", currentChunk);
    formData.append("filename", this.file.name);
    $(`.filename1`).text(this.file.name);
    $(`.textbox1`).text("Uploading file");
    formData.append("end", end);
    formData.append("existingPath", existingPath);
    formData.append("nextSlice", nextChunk);

    $.ajax({
      xhr: function () {
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (e) {
          if (e.lengthComputable) {
            if (self.file.size < self.max_length) {
              var percent = Math.round((e.loaded / e.total) * 100);
            } else {
              var percent = Math.round((uploadedChunk / self.file.size) * 100);
            }
            $(`.progress1`).css("width", percent + "%");
            $(`.progress1`).text(percent + "%");
          }
        });
        return xhr;
      },

      url: `${process.env.VUE_APP_API}/video-uploader/`,
      type: "POST",
      dataType: "json",
      cache: false,
      processData: false,
      contentType: false,
      data: formData,
      error: function (xhr) {
        alert(xhr.statusText);
      },
      success: function (res) {
        if (nextChunk < self.file.size) {
          // upload file in chunks
          existingPath = res.existingPath;
          self.upload_file(nextChunk, existingPath);
        } else {
          // upload complete
          $(`.textbox1`).text(res.data);
          $(`#${append_id}`)
            .val(`${process.env.VUE_APP_API}/media/` + res.existingPath)
            .trigger("input");
          // self.vue.isValidUrl(append_id);
        }
      },
    });
  }
}

class FileUpload {
  constructor(input, bar_url, vueContext) {
    this.bar_url = bar_url;
    this.input = input;
    this.max_length = 1024 * 1024 * 1024 * 100;
    this.vue = vueContext;
  }

  create_progress_bar() {
    var progress = `<div class="file-icon">
                        <i class="fa fa-file-o" aria-hidden="true"></i>
                    </div>
                    <div class="file-details">
       
                         <p class="filename"></p>
                        <small class="textbox"></small>
                        <div class="progressbar">
                            <div class="progress" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">
                            </div>
                        </div>
                    </div>`;
    document.getElementById(this.bar_url).innerHTML = progress;
  }

  upload(append_id) {
    this.create_progress_bar();
    this.initFileUpload(append_id);
  }

  initFileUpload(append_id) {
    this.file = this.input.files[0];
    this.upload_file(0, null, append_id);
  }

  //upload file
  upload_file(start, model_id, append_id) {
    var end;
    var self = this;
    var existingPath = model_id;
    var formData = new FormData();
    var nextChunk = start + this.max_length + 1;
    var currentChunk = this.file.slice(start, nextChunk);
    var uploadedChunk = start + currentChunk.size;
    if (uploadedChunk >= this.file.size) {
      end = 1;
    } else {
      end = 0;
    }

    formData.append("title", "title");

    formData.append("file", currentChunk);
    formData.append("filename", this.file.name);
    $(`.filename`).text(this.file.name);
    $(`.textbox`).text("Uploading file");
    formData.append("end", end);
    formData.append("existingPath", existingPath);
    formData.append("nextSlice", nextChunk);

    $.ajax({
      xhr: function () {
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (e) {
          if (e.lengthComputable) {
            if (self.file.size < self.max_length) {
              var percent = Math.round((e.loaded / e.total) * 100);
            } else {
              var percent = Math.round((uploadedChunk / self.file.size) * 100);
            }
            $(`.progress`).css("width", percent + "%");
            $(`.progress`).text(percent + "%");
          }
        });
        return xhr;
      },

      url: `${process.env.VUE_APP_API}/video-uploader/`,
      type: "POST",
      dataType: "json",
      cache: false,
      processData: false,
      contentType: false,
      data: formData,
      error: function (xhr) {
        alert(xhr.statusText);
      },
      success: function (res) {
        if (nextChunk < self.file.size) {
          // upload file in chunks
          existingPath = res.existingPath;
          self.upload_file(nextChunk, existingPath);
        } else {
          // upload complete
          $(`.textbox`).text(res.data);
          $(`#${append_id}`)
            .val(`${process.env.VUE_APP_API}/media/` + res.existingPath)
            .trigger("input");
          // self.vue.isValidUrl(append_id);
        }
      },
    });
  }
}

import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    Header,
    QuillEditor,
    FlashMessage,
    HodHeader,
    CoordinateHeader,
  },

  data() {
    return {
      disable_submit: false,
      courseInfo: "",
      categories: "",
      messages: {
        text: "",
        type: "null",
      },
      is_CategoryPopup: false,
      description: "<h4>Write your course content</h4>",
      languageList: [],
      courseTypeList: [],
      departments: [],
      programs: [],
      semetser_list: [],
      instructor_lists: [],
      isValidUrlBool: {
        video_url: false,
        pdf_urls: false,
      },
      video_error: "",
      pdf_error: "",

      chunkSize: 1024 * 1024,
      chunkIndex: 0,
      totalChunks: 0,
      file: null,
      title: "Sample Video",
      pdfDisabled: true,
    };
  },

  props: ["course_id"],

  computed: mapGetters(["userInfo"]),
  watch: {
    "courseInfo.outcome": {
      handler(val) {
        this.pdfDisabled = !val || !val.trim();
      },
      immediate: true,
    },
  },

  mounted() {
    const script = document.createElement("script");
    script.src =
      "https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js";
    script.onload = () => {
      console.log("jQuery loaded");
      this.initJQuery();
    };
    document.head.appendChild(script);
  },

  async created() {
    this.getLanguages();
    this.getCourseTypeList();
    this.getPrograms();
    this.sectionsGet();
    this.description = this.courseInfo.description;
    this.getInstructorListByFilter();
    setTimeout(() => {
      this.getProgramsFilter();
      this.getSemesterFilter();
    }, 300);

    // axios
    //   .get(
    //     `${process.env.VUE_APP_API}/courses/?id=${this.course_id}&Key=${this.userInfo.token_key}`
    //   )
    //   .then((response) => {
    //     this.courseInfo = response.data.data.data.data[0];
    //   });

    axios
      .get(
        `${process.env.VUE_APP_API}/courseupdate/${this.course_id}/?Key=${this.userInfo.token_key}`
      )
      .then((response) => {
        console.log(response.data, "response.data.data");
        this.courseInfo = response.data;
      });

    axios
      .get(`${process.env.VUE_APP_API}/category/?format=json`)
      .then((res) => {
        this.categories = res.data.data;
      });
  },

  methods: {
    uploadFilebyChunkNew(file_id, append_id) {
      const fileInput = document.getElementById(`${file_id}`);
      const file = fileInput.files[0];
      if (!file) {
        alert("Please select a file.");
        return;
      }
      this.file = file;
      this.totalChunks = Math.ceil(file.size / this.chunkSize);
      this.chunkIndex = 0;
      this.sendChunk(append_id);
      console.log(append_id, "append_id::1");
    },

    sendChunk(append_id) {
      const start = this.chunkIndex * this.chunkSize;
      const end = Math.min(this.file.size, start + this.chunkSize);
      const chunk = this.file.slice(start, end);

      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("filename", this.file.name);
      formData.append("chunkIndex", this.chunkIndex);
      formData.append("totalChunks", this.totalChunks);
      formData.append("title", this.title);

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${process.env.VUE_APP_API}/video_uploader/chunk/`,
        true
      );
      // xhr.setRequestHeader("X-CSRFToken", getCSRFToken());

      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          document.getElementById("statusCode").innerText = response.message;
          if (response.video_url) {
            const fullUrl = response.video_url;
            // console.log(fullUrl, "::fullUrl::");
            // document.getElementById("videoPath").innerHTML =
            //   `Video URL: <a href="${fullUrl}" target="_blank">${fullUrl}</a>`;
            // let url =
            // if(document.getElementById(`${append_id}`)){
            // console.log(document.getElementById(`${append_id}`));
            console.log(append_id, "append_id::1");
            document.getElementById(`${append_id}`).value = `${fullUrl}`;
            // document.getElementById("videoUrlNew").value = `${fullUrl}`;
            // document.getElementById("getVideoU").value = `${fullUrl}`;

            // if(file_id == "fileupload"){
            //   // videoUrlNew
            //     document.getElementById("videoUrlNew").value = `${fullUrl}`;
            // }
            // else{
            //   document.getElementById("getVideoU").value = `${fullUrl}`;
            // }
            // }
            // console.log(url, "::url::");
          }

          this.chunkIndex++;
          if (this.chunkIndex < this.totalChunks) {
            this.sendChunk(append_id);
          } else {
            alert("Upload complete!");
          }
        } else {
          alert("Upload failed: " + xhr.responseText);
        }
      };

      xhr.send(formData);
    },

    CheckPdfSizeUpload(event) {
      const file = event.target.files[0];
      const maxSize = 50 * 1024 * 1024;
      if (file.size > maxSize) {
        this.pdf_error =
          "Pdf file is larger than 50MB. Please choose a smaller file.";
        event.target.value = "";
        setTimeout(() => {
          this.pdf_error = "";
        }, 5000);
      } else {
        this.pdf_error = "";
      }
    },

    CheckVideoSizeUpload(event) {
      // const file = event.target.files[0];
      // const maxSize = 300 * 1024 * 1024;
      // if (file.size > maxSize) {
      //   this.video_error =
      //     "Video file is larger than 300MB. Please choose a smaller file.";
      //   event.target.value = "";
      //   setTimeout(() => {
      //     this.video_error = "";
      //   }, 5000);
      // } else {
      //   this.video_error = "";
      // }
    },

    convertTimeOnBlur() {
      const el = document.getElementById("total_contact_hours");
      if (!el) return;

      const raw = el.value.trim().replace(/\D/g, "");

      let hours = "00";
      let minutes = "00";

      if (raw.length === 1) {
        hours = `0${raw}`;
      } else if (raw.length === 2) {
        hours = raw;
      } else if (raw.length === 3) {
        hours = raw.slice(0, 2);
        minutes = `${raw[2]}0`;
      } else if (raw.length === 4) {
        hours = raw.slice(0, 2);
        minutes = raw.slice(2, 4);
      } else {
        el.value = "";
        return;
      }

      el.value = `${hours}:${minutes}`;
    },

    initJQuery() {
      $(document).ready(() => {
        console.log("jQuery is ready in this component");
      });
    },

    videoUploadURL(id, bar_url) {
      var uploader = new FileUpload(
        document.querySelector(`#${id}`),
        bar_url,
        this
      );
      console.log(document.querySelector(`#${id}`));
      uploader.upload("video_url");
    },

    pdfUploadURL(id, bar_url) {
      var uploader = new FileUpload1(
        document.querySelector(`#${id}`),
        bar_url,
        this
      );
      console.log(document.querySelector(`#${id}`));
      uploader.upload("pdf_urls");
    },

    // isValidUrl(id) {
    //   // let id = document.getElementById(id).value;
    //   try {
    //     new URL(document.getElementById(id).value);
    //     this.isValidUrlBool[id] = true;
    //     // return true;
    //   } catch (err) {
    //     this.isValidUrlBool[id] = false;
    //     // return false;1
    //   }
    // },

    // isValidUrlMounted(id) {
    //   // let id = document.getElementById(id).value;
    //   try {
    //     new URL(document.getElementById(id).value);
    //     this.isValidUrlBool[id] = true;
    //     // return true;
    //   } catch (err) {
    //     this.isValidUrlBool[id] = false;
    //     // return false;1
    //   }
    // },

    sectionsGet() {
      axios
        .get(
          `${process.env.VUE_APP_API}/section-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.sections = res.data.data;
        });
    },

    getSemesterFilter() {
      let batch_year = 1;
      // let department_name = document.getElementById("department").value;
      // console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${this.courseInfo.department}&batch__id=${batch_year}`
        )
        .then((res) => {
          // this.semetser_list = res.data.data;
          this.semetser_list = res.data.data;
        });
    },

    async getProgramsFilter() {
      // let program_id = document.getElementById("program_id").value;
      // console.log(index);
      await axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${this.courseInfo.program}`
        )
        .then((res) => {
          // this.departments = res.data.data;
          this.departments = res.data.data;
        });
    },

    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },

    getCourseTypeList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.courseTypeList = res.data.data;
        });
    },

    validateNumber(id) {
      let number = document.getElementById(id).value;
      if (number > 9) {
        document.getElementById(id).value = 9;
      }
      // else if (number < 1) {
      //   document.getElementById(id).value = 1;
      // }
    },

    addNumber() {
      document.getElementById("total").value =
        parseInt(document.getElementById("cie").value) +
        parseInt(document.getElementById("see").value);
    },

    getLanguages() {
      axios
        .get(
          `${process.env.VUE_APP_API}/language/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.languageList = res.data.data;
        });
    },
    getInstructorListByFilter() {
      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          console.log(res);
          this.instructor_lists = res.data.products;
        });
    },

    async updateDetails(el) {
      this.disable_submit = true;
      this.description = document.querySelector(".ql-editor").innerHTML;
      console.log(this.description);

      let instructor_details;
      await axios
        .get(
          `${process.env.VUE_APP_API}/coursesdata/${this.course_id}/?Key=${this.userInfo.token_key}`
        )
        .then((Response) => {
          instructor_details = Response.data;
        });

      let updatedCourseInfo = {
        // instructor: instructor_details.instructor_id,
        instructor: this.courseInfo.instructor,
        uid: this.courseInfo.uid,
        title: el.target.elements.title.value,
        slug: this.courseInfo.slug,
        short_description: el.target.elements.shortDesc.value,
        description: this.description,
        outcome: el.target.elements.outcome.value,
        requirements: el.target.elements.requirement.value,
        languages: el.target.elements.languages.value,
        price: 0,
        course_free: true,
        level: el.target.elements.level.value,
        ordered: el.target.elements.order.value,
        // video_url: el.target.elements.video_url.value,
        is_published: el.target.elements.Published.checked,
        created_at: this.courseInfo.created_at,
        updated_at: this.courseInfo.updated_at,
        category: parseInt(el.target.elements.category.value),
        organization_id: instructor_details.organization_id,
        thumbnail: el.target.elements.thumbnail.files[0],
        // new fields for update.
        // pdf_urls: el.target.elements.pdf_urls.value,
        program: el.target.elements.program_id.value,
        department: el.target.elements.department.value,
        semester: el.target.elements.semester.value,
        class_section: el.target.elements.section.value,
        course_type: el.target.elements.course_type.value,
        course_code: el.target.elements.course_code.value,
        cie: el.target.elements.cie.value,
        see: el.target.elements.see.value,
        total_contact_hours: el.target.elements.total_contact_hours.value,
        // no_of_contact_hours:el.target.elements.no_of_contact_hours.value,
        total: el.target.elements.total.value,
        credits: el.target.elements.credits.value,
        exam_duration: el.target.elements.exam_duration.value,
        // tutor_hours:el.target.elements.tutor_hours.value,
        // practical_hours:el.target.elements.practical_hours.value,
        // ltp:el.target.elements.ltp.value,
      };

      if (el.target.elements.pdf_urls.value) {
        updatedCourseInfo["pdf_urls"] = el.target.elements.pdf_urls.value;
      } else {
        updatedCourseInfo["pdf_urls"] = this.courseInfo.pdf_urls;
      }

      if (el.target.elements.video_url.value) {
        updatedCourseInfo["video_url"] = el.target.elements.video_url.value;
      } else {
        updatedCourseInfo["video_url"] = this.courseInfo.video_url;
      }

      await axios
        .put(
          `${process.env.VUE_APP_API}/courseupdate/${this.courseInfo.id}/?Key=${this.userInfo.token_key}`,
          updatedCourseInfo,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.res = response;
          if (this.res.data.message) {
            this.messages = {
              text: "Course Updated successfully",
              type: "success",
            };
            console.log("successful");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.disable_submit = false;
        this.$router.push({
          name: "AdminCoursess",
        });
      }, 2500);
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
